import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Button } from "../../../components/button";
import { CardHeader } from "../../../components/cards";
import { SentinelInput } from "../../sentinels/components";
import { SiteInput } from "../../sites/components";

interface IRoundForm {
  loading: boolean;
  submit: any;
  form: UseFormReturn<any, any>;
  disabledFields?: string[];
}

export const RoundForm: React.FC<IRoundForm> = ({
  loading,
  submit,
  form,
  disabledFields = [],
}) => {
  return (
    <div className="">
      <div className="mb-2"></div>

      <div className="card">
        <CardHeader title="Tournée" />

        <div className="w-full mb-2">
          <SentinelInput form={form} />
        </div>
        <div className="w-full mb-2">
          <SiteInput form={form} />
        </div>

        <div className="w-full mb-2">
          <p className="label">Heure de la tournée</p>
          <input
            className="w-full input"
            {...form.register("hour", {
              required: "L'heure est requise",
            })}
            placeholder="18"
          />
        </div>

        <div className="w-full py-3">
          <Button
            disabled={!form.formState.isValid}
            loading={loading}
            onClick={submit}
          >
            Valider
          </Button>
        </div>
      </div>
    </div>
  );
};
